import React from 'react';

interface WifiIndicatorProps {
  iconvalue: string | number;
  className?: string;
  size?: number;
}

export default function WifiIndicator({ iconvalue, className = '', size = 24 }: WifiIndicatorProps) {
  // Convert WiFi value to number if it's a string (same as mobile app)
  const rssi = typeof iconvalue === 'string' ? parseFloat(iconvalue) : iconvalue;
  
  // Determine signal strength and color based on RSSI value (exact mobile app logic)
  const getSignalConfig = () => {
    if (isNaN(rssi) || rssi === 0) {
      return { strength: 0, color: "#ccc", bars: 0 }; // No signal
    } else if (rssi >= -50) {
      return { strength: 4, color: "#4CAF50", bars: 4 }; // Excellent signal
    } else if (rssi >= -60) {
      return { strength: 3, color: "#8BC34A", bars: 3 }; // Good signal
    } else if (rssi >= -70) {
      return { strength: 2, color: "#FFC107", bars: 2 }; // Fair signal
    } else if (rssi >= -80) {
      return { strength: 1, color: "#FF9800", bars: 1 }; // Poor signal
    } else {
      return { strength: 0, color: "#F44336", bars: 0 }; // Very poor signal
    }
  };

  const signalConfig = getSignalConfig();
  const { color, bars } = signalConfig;

  // Calculate dimensions (for potential future use)

  return (
    <div className={`flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        {/* WiFi center dot */}
        <circle 
          cx="12" 
          cy="18" 
          r="1.5" 
          fill={bars >= 1 ? color : "#E5E7EB"}
        />
        
        {/* WiFi arc 1 (innermost) */}
        <path 
          d="M 8.5 14.5 A 5 5 0 0 1 15.5 14.5"
          stroke={bars >= 2 ? color : "#E5E7EB"}
          strokeWidth="2" 
          fill="none"
          strokeLinecap="round"
        />
        
        {/* WiFi arc 2 (middle) */}
        <path 
          d="M 6 11 A 8.5 8.5 0 0 1 18 11"
          stroke={bars >= 3 ? color : "#E5E7EB"}
          strokeWidth="2" 
          fill="none"
          strokeLinecap="round"
        />
        
        {/* WiFi arc 3 (outermost) */}
        <path 
          d="M 3.5 7.5 A 12 12 0 0 1 20.5 7.5"
          stroke={bars >= 4 ? color : "#E5E7EB"}
          strokeWidth="2" 
          fill="none"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
} 